import React, { FC, useMemo } from 'react';
import { Typography } from '../../../../shared/typography';
import Select from '../../../select';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';

interface IInputProps {
	title: string;
	value: any;
	fields: any;
	callback(props: any): void;
}

const TimeRange: FC<IInputProps> = ({
	title,
	value,
	fields: groupingFields,
	callback,
}) => {
	const timeFields = useMemo(() => {
		if (!groupingFields || !groupingFields.length)
			return [{ title: 'Created Date', type: 'CreatedDate' }];
		return [...new Set(['CreatedDate', ...groupingFields])].map(
			(field: any) => ({
				title: field.match(/[A-Z][a-z]+/g)?.join(' '),
				type: field,
			})
		);
	}, [groupingFields]);

	const timeUnits = useMemo(
		() => [
			{
				title: 'No unit',
				type: '',
			},
			{
				title: 'Day',
				type: 'day',
			},
			{
				title: 'Week',
				type: 'week',
			},
			{
				title: 'Month',
				type: 'month',
			},
			{
				title: 'Quarter',
				type: 'quarter',
			},
			{
				title: 'Year',
				type: 'year',
			},
		],
		[]
	);

	const timeRanges = useMemo(
		() => [
			{
				title: 'No range',
				type: '',
			},
			{
				title: 'Last',
				type: 'last',
			},
			{
				title: 'This',
				type: 'this',
			},
			{
				title: 'Next',
				type: 'next',
			},
			{
				title: 'This and Last',
				type: 'this & last',
			},
		],
		[]
	);

	const groups = useMemo(
		() => [
			{
				title: 'Time field',
				data: timeFields,
				field: 'field',
			},
			{
				title: 'Time unit',
				data: timeUnits,
				field: 'unit',
			},
		],
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[timeFields]
	);

	console.log(value.range);

	if (!value) return null;

	return (
		<div style={{ width: '100%' }}>
			<div>
				<Typography type="bold" size="medium" text={title} />
			</div>
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				{groups.map((group, i) => {
					const newValue = group?.data?.find(
						(option: any) => option.type === value[group.field]
					);
					return (
						<div key={i}>
							<Select
								options={group.data}
								callback={(option: any) =>
									callback({ [group.field]: option.type })
								}
								value={newValue?.title || group?.data[0]?.title}
							/>
						</div>
					);
				})}
			</div>
			<RadioGroup
				row
				style={{ width: '100%' }}
				onChange={event => callback({ range: event.target.value })}
				defaultValue={value.range || timeRanges[0].type}
			>
				{timeRanges.map(timeRange => (
					<FormControlLabel
						control={
							<Radio
								sx={{
									'&, &.Mui-checked': {
										color: 'black',
									},
								}}
								size="small"
							/>
						}
						label={<Typography size="tiny">{timeRange.title}</Typography>}
						value={timeRange.type}
					/>
				))}
			</RadioGroup>
		</div>
	);
};

export default TimeRange;
